import { useTheme } from 'styled-components';

import { DATES_STATUS_TYPES } from '@constants/constants';

import { getDateColor } from './helpers';
import {
  DateTypesCircle,
  DateTypesItem,
  DateTypesLabel,
  DateTypesWrapper,
} from './styled';

const DateStatusTypes = () => {
  const { palette } = useTheme();
  return (
    <DateTypesWrapper>
      {DATES_STATUS_TYPES.map((statusType) => (
        <DateTypesItem key={statusType.label}>
          <DateTypesCircle
            backgroundColor={getDateColor(palette, statusType?.type)}
          />
          <DateTypesLabel>{statusType.label}</DateTypesLabel>
        </DateTypesItem>
      ))}
    </DateTypesWrapper>
  );
};

export default DateStatusTypes;
